import { render, staticRenderFns } from "./AlertsPage.vue?vue&type=template&id=6fc4bd82"
import script from "./AlertsPage.vue?vue&type=script&lang=js"
export * from "./AlertsPage.vue?vue&type=script&lang=js"
import style0 from "./AlertsPage.vue?vue&type=style&index=0&id=6fc4bd82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports